._content_1006j_1 {
  max-width: 680px; }

._container_1006j_4 {
  margin: 8px 24px 24px 24px; }
